import { render, staticRenderFns } from "./DispositivosNoSeriadosEdicion.vue?vue&type=template&id=0b09d8ac&"
import script from "./DispositivosNoSeriadosEdicion.vue?vue&type=script&lang=ts&"
export * from "./DispositivosNoSeriadosEdicion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports